'use strict';

angular.module('quantixApp').directive(
		'numericOnly', function() {
			return {
				require: 'ngModel',
				restrict: 'A',
				link: function(scope, element, attrs, ctrl) {
					ctrl.$parsers.push(function(inputValue) {
						if (inputValue == null) {
							return '';
						}
						var cleanInputValue = inputValue.replace(/[^0-9]/gi, '');
						if (cleanInputValue != inputValue) {
							ctrl.$setViewValue(cleanInputValue);
							ctrl.$render();
						}
						return cleanInputValue;
					});
				}
			}
  });
